
import { css } from 'lit';
export default css`
:host {
  display: flex;
}

.btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-width: 2px;
  border-color: transparent;
  --tw-bg-opacity: 1;
  background-color: rgba(107, 31, 153, var(--tw-bg-opacity));
  padding-top: 1rem;
  padding-bottom: 1rem;
  padding-left: 2rem;
  padding-right: 2rem;
  text-align: center;
  font-family: Lato, sans-serif;
  font-weight: 700;
  line-height: 1;
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, var(--tw-text-opacity));
  text-decoration: none;
}

@media (min-width: 1024px) {

  .btn {
    font-size: 1.25rem;
  }
}

.btn a {
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, var(--tw-text-opacity));
}

.btn:hover, .btn:focus {
  --tw-bg-opacity: 1;
  background-color: rgba(53, 25, 108, var(--tw-bg-opacity));
}

.btn:hover, .btn:focus {
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, var(--tw-text-opacity));
}

.btn:hover, .btn:focus {
  text-decoration: none;
}

.btn:hover, .btn:focus {
    cursor: pointer;
  }

.btn:focus {
  --tw-shadow: 0 0 20px 0 rgba(107, 31, 153, 0.6);
  box-shadow: 0 0 #0000, 0 0 #0000, var(--tw-shadow);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.btn:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.btn:disabled {
  --tw-bg-opacity: 1;
  background-color: rgba(164, 167, 171, var(--tw-bg-opacity));
}

.btn .link--external__icon {
    width: 1rem;
    height: 1rem;
    margin-left: 0.5rem;
  }

.btn__icon {
  margin-left: 0.5rem;
  margin-right: 0.5rem;
}

.btn__icon {
  display: inline-block;
}

.btn__icon {
  height: 1rem;
}

.btn__icon {
  width: 1rem;
}

.btn--primary--grow, .btn--secondary--grow, .btn--primary-lg--grow, .btn--primary-white--grow, .btn--tertiary--grow {
  flex-grow: 1;
}

.btn--primary-lg, .btn--primary-lg--grow {
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
}

.btn--primary-lg, .btn--primary-lg--grow {
  padding-left: 2.5rem;
  padding-right: 2.5rem;
}

@media (min-width: 1024px) {

  .btn--primary-lg, .btn--primary-lg--grow {
    font-size: 1.25rem;
  }
}

.btn--primary-white-search, .btn--primary-white, .btn--primary-white--grow {
  margin-left: 0.75rem;
  margin-right: 0.75rem;
}

.btn--primary-white-search, .btn--primary-white, .btn--primary-white--grow {
  --tw-border-opacity: 1;
  border-color: rgba(255, 255, 255, var(--tw-border-opacity));
}

.btn--primary-white-search, .btn--primary-white, .btn--primary-white--grow {
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
}

.btn--primary-white-search, .btn--primary-white, .btn--primary-white--grow {
  padding-left: 2.5rem;
  padding-right: 2.5rem;
}

@media (min-width: 1024px) {

  .btn--primary-white-search, .btn--primary-white, .btn--primary-white--grow {
    font-size: 1.25rem;
  }
}

.btn--primary-white-search {
  --tw-border-opacity: 1;
  border-color: rgba(107, 31, 153, var(--tw-border-opacity));
}

.btn--primary-white-search {
  --tw-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
}

.btn--primary-white-search {
  --tw-text-opacity: 1;
  color: rgba(107, 31, 153, var(--tw-text-opacity));
}

@media (min-width: 768px) {

  .btn--primary-white-search {
    --tw-border-opacity: 1;
    border-color: rgba(255, 255, 255, var(--tw-border-opacity));
  }
}

@media (min-width: 768px) {

  .btn--primary-white-search {
    --tw-bg-opacity: 1;
    background-color: rgba(107, 31, 153, var(--tw-bg-opacity));
  }
}

@media (min-width: 768px) {

  .btn--primary-white-search {
    --tw-text-opacity: 1;
    color: rgba(255, 255, 255, var(--tw-text-opacity));
  }
}

.btn--primary-white-search {
    margin: 0;
    padding: 0;
    height: 40px;
    width: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-width: 1px;
  }

.btn--primary-white-search .btn__icon {
      margin-left: 6px;
      padding: 0;
      max-width: 131px;
      margin-top: 4px;
    }

@media (min-width: 768px) {

.btn--primary-white-search {
      padding: 1.25rem 2.5rem;
      margin: 0 0 0 24px;
      height: auto;
      width: auto;
      border-width: 2px
  }
    }

.btn--secondary, .btn--secondary--grow {
  --tw-border-opacity: 1;
  border-color: rgba(107, 31, 153, var(--tw-border-opacity));
}

.btn--secondary, .btn--secondary--grow {
  --tw-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
}

.btn--secondary, .btn--secondary--grow {
  --tw-text-opacity: 1;
  color: rgba(107, 31, 153, var(--tw-text-opacity));
}

.btn--secondary a, .btn--secondary--grow a {
  --tw-text-opacity: 1;
  color: rgba(107, 31, 153, var(--tw-text-opacity));
}

.btn--secondary:hover, .btn--secondary:focus, .btn--secondary--grow:hover, .btn--secondary--grow:focus {
  --tw-bg-opacity: 1;
  background-color: rgba(107, 31, 153, var(--tw-bg-opacity));
}

.btn--secondary:hover, .btn--secondary:focus, .btn--secondary--grow:hover, .btn--secondary--grow:focus {
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, var(--tw-text-opacity));
}

.btn--secondary:hover a, .btn--secondary:focus a, .btn--secondary--grow:hover a, .btn--secondary--grow:focus a {
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, var(--tw-text-opacity));
}

.btn--secondary:disabled, .btn--secondary--grow:disabled {
  --tw-border-opacity: 1;
  border-color: rgba(164, 167, 171, var(--tw-border-opacity));
}

.btn--secondary:disabled, .btn--secondary--grow:disabled {
  --tw-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
}

.btn--secondary:disabled, .btn--secondary--grow:disabled {
  --tw-text-opacity: 1;
  color: rgba(164, 167, 171, var(--tw-text-opacity));
}

.btn--secondary-compact {
  --tw-border-opacity: 1;
  border-color: rgba(107, 31, 153, var(--tw-border-opacity));
}

.btn--secondary-compact {
  --tw-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
}

.btn--secondary-compact {
  padding-left: 1rem;
  padding-right: 1rem;
}

.btn--secondary-compact {
  --tw-text-opacity: 1;
  color: rgba(107, 31, 153, var(--tw-text-opacity));
}

.btn--secondary-compact:hover, .btn--secondary-compact:focus {
  --tw-bg-opacity: 1;
  background-color: rgba(107, 31, 153, var(--tw-bg-opacity));
}

.btn--secondary-compact:hover, .btn--secondary-compact:focus {
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, var(--tw-text-opacity));
}

.btn--secondary-compact .btn__icon {
  margin: -0.25rem;
}

.btn--secondary-compact .btn__icon {
  padding: 0px;
}

.btn--tertiary, .btn--tertiary--grow {
  --tw-border-opacity: 1;
  border-color: rgba(255, 255, 255, var(--tw-border-opacity));
}

.btn--tertiary:hover, .btn--tertiary:focus, .btn--tertiary--grow:hover, .btn--tertiary--grow:focus {
  --tw-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
}

.btn--tertiary:hover, .btn--tertiary:focus, .btn--tertiary--grow:hover, .btn--tertiary--grow:focus {
  --tw-text-opacity: 1;
  color: rgba(107, 31, 153, var(--tw-text-opacity));
}

.btn--tertiary:disabled, .btn--tertiary--grow:disabled {
  --tw-border-opacity: 1;
  border-color: rgba(232, 194, 255, var(--tw-border-opacity));
}

.btn--tertiary:disabled, .btn--tertiary--grow:disabled {
  --tw-bg-opacity: 1;
  background-color: rgba(107, 31, 153, var(--tw-bg-opacity));
}

.btn--tertiary:disabled, .btn--tertiary--grow:disabled {
  --tw-text-opacity: 1;
  color: rgba(232, 194, 255, var(--tw-text-opacity));
}

.btn--compact {
  padding-left: 1rem;
  padding-right: 1rem;
}

.btn--compact .btn__icon {
  margin: 0px;
}

.btn--compact .btn__icon {
  padding: 0px;
}

.btn--compact-text {
  padding-left: 1rem;
  padding-right: 1rem;
}

.btn--compact-text .btn__icon {
  margin-left: 0.5rem;
}

.btn--compact-text .btn__icon {
  padding: 0px;
}

.btn--image-nav, .btn--image-nav-secondary {
  display: flex;
}

.btn--image-nav, .btn--image-nav-secondary {
  width: 100%;
}

.btn--image-nav, .btn--image-nav-secondary {
  flex-direction: column;
}

.btn--image-nav, .btn--image-nav-secondary {
  align-items: flex-start;
}

.btn--image-nav, .btn--image-nav-secondary {
  justify-content: flex-start;
}

.btn--image-nav, .btn--image-nav-secondary {
  justify-content: space-between;
}

.btn--image-nav, .btn--image-nav-secondary {
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}

.btn--image-nav, .btn--image-nav-secondary {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}

.btn--image-nav, .btn--image-nav-secondary {
  text-align: left;
}

.btn--image-nav, .btn--image-nav-secondary {
  font-size: 0.9375rem;
}

.btn--image-nav, .btn--image-nav-secondary {
  text-transform: uppercase;
}

.btn--image-nav, .btn--image-nav-secondary {
    height: 120px
  }

@media (min-width: 640px) {

  .btn--image-nav, .btn--image-nav-secondary {
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }
}

@media (min-width: 640px) {

  .btn--image-nav, .btn--image-nav-secondary {
    font-size: 0.875rem;
  }
}

@media (min-width: 768px) {

  .btn--image-nav, .btn--image-nav-secondary {
    padding: 1rem;
  }
}

@media (min-width: 768px) {

.btn--image-nav, .btn--image-nav-secondary {
      height: 90px
  }
    }

@media (min-width: 1200px) {

  .btn--image-nav, .btn--image-nav-secondary {
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
  }
}

@media (min-width: 1200px) {

.btn--image-nav, .btn--image-nav-secondary {
      height: 108px
  }
    }

@media (min-width: 1366px) {

  .btn--image-nav, .btn--image-nav-secondary {
    padding-left: 0.75rem;
    padding-right: 0.75rem;
  }
}

@media (min-width: 1366px) {

  .btn--image-nav, .btn--image-nav-secondary {
    font-size: 0.9375rem;
  }
}

.btn--image-nav .btn__icon, .btn--image-nav-secondary .btn__icon {
  margin: 0px;
}

.btn--image-nav .btn__icon, .btn--image-nav-secondary .btn__icon {
  align-self: flex-start;
}

.btn--image-nav .btn__icon, .btn--image-nav-secondary .btn__icon {
  padding: 0px;
}

.btn--image-nav-secondary {
  --tw-border-opacity: 1;
  border-color: rgba(107, 31, 153, var(--tw-border-opacity));
}

.btn--image-nav-secondary {
  --tw-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
}

.btn--image-nav-secondary {
  --tw-text-opacity: 1;
  color: rgba(107, 31, 153, var(--tw-text-opacity));
}

.btn--menu {
  border-width: 0px;
}

.btn--menu {
  --tw-bg-opacity: 1;
  background-color: rgba(53, 25, 108, var(--tw-bg-opacity));
}

.btn--menu {
  padding: 1.25rem;
}

.btn--menu {
  font-size: 0.875rem;
}

.btn--menu {
  text-transform: uppercase;
}

@media (min-width: 768px) {

  .btn--menu {
    font-size: 1.125rem;
  }
}

.btn--menu:hover, .btn--menu:focus {
  --tw-bg-opacity: 1;
  background-color: rgba(107, 31, 153, var(--tw-bg-opacity));
}

.btn--menu .btn__icon {
  margin: 0px;
}

.btn--menu .btn__icon {
  height: 1.5rem;
}

.btn--menu .btn__icon {
  width: 1.5rem;
}

.btn--menu .btn__icon {
  align-self: flex-start;
}

.btn--menu .btn__icon {
  padding: 0px;
}

@media (min-width: 768px) {

  .btn--menu .btn__icon {
    height: 2rem;
  }
}

@media (min-width: 768px) {

  .btn--menu .btn__icon {
    width: 2rem;
  }
}

.btn--menu-close {
  border-width: 0px;
}

.btn--menu-close {
  --tw-bg-opacity: 1;
  background-color: rgba(53, 25, 108, var(--tw-bg-opacity));
}

.btn--menu-close {
  padding: 1.25rem;
}

.btn--menu-close:hover, .btn--menu-close:focus {
  --tw-bg-opacity: 1;
  background-color: rgba(107, 31, 153, var(--tw-bg-opacity));
}

.btn--menu-close .btn__icon {
  margin: 0px;
}

.btn--menu-close .btn__icon {
  height: 1.5rem;
}

.btn--menu-close .btn__icon {
  width: 1.5rem;
}

.btn--menu-close .btn__icon {
  align-self: flex-start;
}

.btn--menu-close .btn__icon {
  padding: 0px;
}

@media (min-width: 768px) {

  .btn--menu-close .btn__icon {
    height: 2rem;
  }
}

@media (min-width: 768px) {

  .btn--menu-close .btn__icon {
    width: 2rem;
  }
}

.btn--inline {
    display: inline-block;
    text-align: inherit;
  }

.btn--search-external {
  --tw-bg-opacity: 1;
  background-color: rgba(53, 25, 108, var(--tw-bg-opacity));
}

.btn--search-external {
    text-align: left;
    padding: 1rem;
    font-size: 20px;
    font-weight: 400;
    line-height: 24px;
    letter-spacing: 0px;
    width: 100%;
    justify-content: flex-start;
    align-items: flex-start;
  }

.btn--search-external .btn__icon {
      margin-left: auto;
      margin-top: 5px;
    }

.btn--search-external:hover, .btn--search-external:focus {
  --tw-bg-opacity: 1;
  background-color: rgba(107, 31, 153, var(--tw-bg-opacity));
}

.btn--search-all {
  width: 100%;
}

.btn--search-all .btn__icon {
  margin-left: 1rem;
}

.btn--search-all .btn__icon {
  margin-top: 2px;
}
`;